<template>
  <div class="patterns">
    <carousel
      :perPageCustom="[[300, 1], [768, 3], [1024, 4]]"
      pagination-active-color="#ffffff"
      pagination-color="rgba(213, 207, 198, .3)"
    >
      <slide
        v-for="pattern in orderedPatterns"
        :key="pattern.id"
      >
        <circle-select
          :option="{ fillImage: pattern.icon }"
          :isSelected="pattern.name == pathfinder.pattern"
          @click.native="setPattern(pattern.name)"
          :style="{ margin: 'auto', height: '8em', width: '8em' }"
        ></circle-select>
      </slide>
    </carousel>
  </div>
</template>

<script>
  import { Carousel, Slide } from "vue-carousel";
  import { mapState, mapGetters, mapActions } from "vuex";
  import CircleSelect from "@/components/CircleSelect.vue";

  export default {
    components: {
      Carousel,
      Slide,
      CircleSelect
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder,
        patterns: state => state.patterns.patterns
      }),
      orderedPatterns() {
        return this.patterns.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
    },
    methods: {
      ...mapActions(["softUpdatePathfinder"]),
      setPattern(pattern) {
        this.softUpdatePathfinder({ pattern });
      }
    }
  };
</script>

<style>
</style>
